<template>
  <Modal
    :title="$t('customize_heading_block')"
    :form="{ data: form, method: 'PUT', endpoint: `collections/${personalisationHashid}/blocks/${blockHashid}/customise` }"
    :confirm-label="$t('save')"
    @confirm="$modal.close"
  >
    <InputGroup name="title">
      <TextInput
        v-model="form.title"
        name="title"
      />
    </InputGroup>
  </Modal>
</template>

<script setup lang="ts">
import type { HeadingBlock } from '~/types/blocks'

const props = defineProps<{
  personalisationHashid: string
  blockHashid: string
}>()

const { data } = await useAsyncData(`customise-block-${props.personalisationHashid}-${props.blockHashid}`, () =>
  $larafetch<HeadingBlock>(`collections/${props.personalisationHashid}/blocks/${props.blockHashid}`)
)

if (!data.value) {
  throw createError({ statusMessage: 'Failed to fetch block' })
}

const form = reactive({
  title: data.value.item.title
})
</script>
